module.exports = __webpack_public_path__ + "img/stan_invest_logo.ade94b27.png";